import React, { ReactNode } from 'react'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  children: ReactNode
  size?: 'sm' | 'md' | 'lg'
}

export function Modal({ isOpen, onClose, title, children, size = 'md' }: ModalProps): React.ReactElement | null {
  if (!isOpen) return null

  const sizeClasses = {
    sm: 'w-full max-w-sm',
    md: 'w-full max-w-2xl',
    lg: 'w-full max-w-4xl',
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className={`${sizeClasses[size]} bg-white rounded-3xl border-4 border-purple-300 shadow-2xl max-h-[90vh] overflow-y-auto`}>
        {/* Header */}
        <div className="sticky top-0 flex items-center justify-between p-6 bg-gradient-to-r from-purple-100 to-pink-100 border-b-4 border-purple-300 rounded-t-3xl">
          <h2 className="text-3xl font-black text-purple-700">{title}</h2>
          <button
            onClick={onClose}
            className="text-4xl font-black text-purple-700 hover:text-purple-900 transition leading-none"
            aria-label="Close modal"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="p-8">
          {children}
        </div>

        {/* Footer with close button */}
        <div className="sticky bottom-0 p-6 bg-gradient-to-r from-purple-50 to-pink-50 border-t-4 border-purple-200 rounded-b-3xl flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-8 py-2 bg-purple-400 text-white font-black rounded-full hover:bg-purple-500 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
